import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const ConfirmDialog = ({ open, onClose, onConfirm, title, message }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={() => onClose(false)}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)} variant="outlined" color="primary">
          {t("cancel")}
        </Button>
        <Button onClick={onConfirm} variant="contained" color="error" autoFocus>
          {t("ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
